import { render, staticRenderFns } from "./CallStats.vue?vue&type=template&id=5976685c&"
import script from "./CallStats.vue?vue&type=script&lang=js&"
export * from "./CallStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports